import React, { useState, useEffect, useContext, memo } from "react"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import { getDesignations } from "@/apisParticipantPublic"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import { makeStyles } from "@material-ui/core/styles"
import clsx from "clsx"
import InvitationContext from "@/components/invitation/InvitationContext"

const useStyles = makeStyles((theme) => ({
    radioLabel: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        border: "1px solid",
        borderColor: theme.palette.sparcaLightGrey.main,
        width: "235px",
        marginLeft: 0,
    },
    radioGroup: {
        margin: theme.spacing(3, 0),
        display: "flex",
        flexWrap: "wrap",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
    },
}))

const Designation = memo((props) => {
    const { handleUpdateParticipant, setParticipantDetailError, setParticipantRoleSettingError } = props
    const { participantDetail } = useContext(InvitationContext)
    const classes = useStyles()
    const [designations, setDesignations] = useState([])
    const [checkedDesignationId, setCheckedDesignationId] = useState(0)
    const [designationLoading, setDesignationLoading] = useState({
        loading: true,
        error: false,
        message: "",
    })
    const handleDesignationChange = (event) => {
        setCheckedDesignationId(Number(event.target.value))
        handleUpdateParticipant("designationId", Number(event.target.value))
        setParticipantRoleSettingError({
            show: false,
            message: "",
        })
    }
    useEffect(() => {
        const getDesignationsFunc = async (companyId) => {
            if (companyId) {
                try {
                    const resultDesignationsData = await getDesignations(companyId)
                    const resultDesignations = resultDesignationsData.data.designations
                    setDesignations(resultDesignations)
                    setDesignationLoading({
                        loading: false,
                        error: false,
                        message: null,
                    })
                } catch (error) {
                    setDesignationLoading({
                        loading: false,
                        error: true,
                        message: "error",
                    })
                    setParticipantDetailError({ status: true, message: "setting loading wrong", update: false })
                }
            }
        }
        getDesignationsFunc(participantDetail.projects.companyId)
    }, [participantDetail.projects.companyId])

    return (
        <Box className="designation-wrapper">
            {designationLoading.loading ? (
                <Box>
                    <Typography>Loading designations... </Typography>
                </Box>
            ) : (
                <>
                    <Box className="sub-title designation-title">
                        <Typography variant="h6" component="h2" style={{ color: "black" }}>
                            Which Designation Best Suits Your Designation?
                        </Typography>
                    </Box>
                    <Box>
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="designation"
                                name="designation"
                                value={checkedDesignationId}
                                onChange={handleDesignationChange}
                                className={classes.radioGroup}
                            >
                                {designations.map((designation) => {
                                    return (
                                        <FormControlLabel
                                            className={clsx(classes.radioLabel)}
                                            value={designation.designationId}
                                            label={designation.designation}
                                            control={<Radio />}
                                            key={designation.designationId}
                                        />
                                    )
                                })}
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </>
            )}
        </Box>
    )
})
export default Designation
